"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconChat = function SvgIconChat(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "chat icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Chat Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M38.398 6c2.974 0 5.415 2.302 5.592 5.217l.01.34v17.775c0 2.96-2.331 5.372-5.261 5.547l-.34.01-13.803-.001-13.409 8.832.031-8.832H9.601c-2.974 0-5.414-2.301-5.59-5.217L4 29.33V11.557c0-2.96 2.33-5.371 5.26-5.546L9.6 6h28.798zm0 4H9.601c-.816 0-1.481.59-1.586 1.346l-.015.21v17.776c0 .783.598 1.439 1.383 1.543l.218.014h5.63l-.019 5.391 8.189-5.391h14.997c.816 0 1.482-.59 1.587-1.347l.015-.21V11.556c0-.782-.598-1.438-1.383-1.542L38.398 10z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 18h24v-4H12zm0 8h12v-4H12z"
  }));
};

var _default = SvgIconChat;
exports.default = _default;